import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
const URL_BASIC = 'https://www.tera-ventasonline.shop/cart/45074512609395:1';
const URL_MASTER = 'https://www.tera-ventasonline.shop/cart/45074512740467:1';
export const Pricing: React.FC = () => {
  return <Section id="pricing" data-id="element-209">
      <div className="text-center mb-12 md:mb-16" data-id="element-210">
        <h2 className="text-4xl md:text-6xl font-black mb-4" data-id="element-211">
          ELEGÍ TU MEGAPACK
        </h2>
      </div>

      <div className="grid grid-cols-1 gap-3 md:gap-8 max-w-5xl mx-auto md:items-center" data-id="element-212">
        {/* Plan A */}
        <div className="bg-brand-card border border-brand-card-border rounded-2xl md:rounded-3xl p-4 md:p-10 flex flex-col md:h-full gap-3 md:gap-0" data-id="element-213">
          <div className="flex-1 min-w-0" data-id="element-214">
            <h3 className="text-base md:text-2xl font-black text-white mb-1 md:mb-2 leading-tight" data-id="element-215">
              📘 MEGAPACK NIVEL INICIAL
            </h3>
            <p className="text-brand-green font-bold text-xs md:text-base mb-2 md:mb-6" data-id="element-216">
              6 Tomos + 6 Bonos
            </p>

            <div className="hidden md:block mb-8 flex-grow" data-id="element-217">
              <p className="text-sm text-gray-400 font-medium mb-1" data-id="element-218">
                Ideal para:
              </p>
              <p className="text-white font-semibold text-base" data-id="element-219">
                Todas las salas — 18m · 2 · 3 años
              </p>
            </div>

            <div className="mb-0 md:mb-8" data-id="element-220">
              <span className="text-gray-500 line-through text-sm md:text-xl font-bold block leading-none mb-0.5 md:mb-1" data-id="element-221">
                $45.000
              </span>
              <div className="flex items-baseline gap-1 md:gap-2" data-id="element-222">
                <span className="text-2xl md:text-5xl font-black text-white" data-id="element-223">
                  $19.990
                </span>
                <span className="text-xs md:text-xl font-bold text-gray-400" data-id="element-224">
                  ARS
                </span>
              </div>
            </div>
          </div>

          <Button href={URL_BASIC} variant="secondary" fullWidth className="shrink-0 !px-4 md:!px-8 !py-3 md:!py-4 !text-xs md:!text-lg text-center" data-id="element-225">
            → QUIERO MI MEGAPACK
          </Button>
        </div>

        {/* Plan B - Highlighted */}
        <div className="bg-gradient-to-b from-brand-card to-brand-dark border-2 border-brand-green rounded-2xl md:rounded-3xl p-4 md:p-10 relative shadow-[0_0_40px_rgba(34,197,94,0.15)] flex flex-col md:h-full gap-3 md:gap-0" data-id="element-226">
          <div className="absolute top-0 right-3 md:right-auto md:left-1/2 md:-translate-x-1/2 -translate-y-1/2 bg-brand-green text-black font-black px-3 md:px-6 py-1 md:py-2 rounded-full text-[10px] md:text-sm uppercase tracking-wider whitespace-nowrap" data-id="element-227">
            MÁS ELEGIDO ⭐
          </div>

          <div className="flex-1 min-w-0" data-id="element-228">
            <h3 className="text-base md:text-2xl font-black text-white mb-1 md:mb-2 leading-tight" data-id="element-229">
              🏆 MEGAPACK + MÁSTER PROFESIONAL
            </h3>
            <p className="text-brand-green font-bold text-xs md:text-base mb-2 md:mb-6" data-id="element-230">
              6 Tomos + 6 Bonos + Máster de Personalización Docente
            </p>

            <div className="hidden md:block mb-8 flex-grow" data-id="element-231">
              <p className="text-sm text-gray-400 font-medium mb-1" data-id="element-232">
                Ideal para:
              </p>
              <p className="text-white font-semibold text-base" data-id="element-233">
                Docentes que quieren blindaje profesional, protocolos de crisis
                y carpeta infalible
              </p>
            </div>

            <div className="mb-0 md:mb-8" data-id="element-234">
              <span className="text-gray-500 line-through text-sm md:text-xl font-bold block leading-none mb-0.5 md:mb-1" data-id="element-235">
                $65.000
              </span>
              <div className="flex items-baseline gap-1 md:gap-2" data-id="element-236">
                <span className="text-2xl md:text-5xl font-black text-brand-green" data-id="element-237">
                  $27.990
                </span>
                <span className="text-xs md:text-xl font-bold text-gray-400" data-id="element-238">
                  ARS
                </span>
              </div>
            </div>
          </div>

          <Button href={URL_MASTER} variant="primary" fullWidth className="shrink-0 !px-4 md:!px-8 !py-3 md:!py-4 !text-xs md:!text-lg text-center" data-id="element-239">
            → QUIERO EL MEGAPACK + MÁSTER
          </Button>
        </div>
      </div>
    </Section>;
};